/**
 * Funds Instrument Configuration
 */

import Fund from '@/types/fund';
import { ADVANCED_SEARCH_OPTIONS } from '@/utils/constants';
import { FundFilters, FundSearchParams } from '../types';
import { createInstrumentConfig } from '../utils';

export const fundsInstrumentConfig = createInstrumentConfig<Fund, FundFilters, FundSearchParams>({
  type: ADVANCED_SEARCH_OPTIONS.FUNDS,
  endpoints: {
    filters: '/funds/filters',
    search: '/funds/search',
  },
});
